import './TransferTab.css';
import SectionTitleWithHr from '../../components/SectionTitleWithHR/SectionTitleWithHr';
import { useEffect, useState } from 'react';
import LabelValueDisplay from '../../components/LabelValue/LabelValueDisplay';
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import _ from 'lodash';
import DP_Dropdown from '../../../../../components/InventoryWarehouseTable/DP_Dropdown';
import { getDeRegisterDeviceData, getDeviceLinkStatusData, getSwapModeData } from '../../../../../actions/Users/authenticateOpenEdgeService';
import { fetchResources, getOrganisationInfo } from '../../../../../actions/Users/authenticate';
import { CREATE_AND_ASSIGN_INVENTORY, GET_UPGRADE_INVENTORY_LICENSE, INVENTORY_CHANGE_GROUP, FETCH_OU_RESOURCES, GET_DEVICE_TRANSFER, GET_CANCEL_DE_REGISTER, GET_PAUSE_LICENSE, GET_WH_ProdGP_DEVICE_LIST, GET_TRANSFER_LICENSE, GET_DP_INFO, GET_CANCEL_PAUSE_LICENSE, GET_RESUME_LICENSE, TRACK_INVENTORY_SYNC_DATA } from '../../../../../actions/types';
import CustomLoader from '../../../../../components/Loader/CustomLoader';
import { Box, Grid } from '@mui/material';
import AddButton from '../../components/AddButton/AddButton';
import AddEditInterfaceModal from '../../components/Modals/AddEditInterfaceModal';
import InfoModal from '../../components/Modals/InfoModal';
import { createVessel, getDeviceTransferData, inventoryChangeGroup, moveDeviceToWarehouse, upgradeInventoryLicense, getCancelDeRegisterData, getPauseLicenseData, getResumeLicenseData, getWHProdGPDeviceListData, getTransferLicenseData, getCancelPauseLicenseData, trackInventorySyncStatusData } from '../../../../../actions/Users/authenticateInventory';
import ChangeLicense from '../SystemTab/ChangeLicense';
import { formatToReadable, getDataFromLocalStorage, getDecodeURI, getEncodedURI, hasLicensePermission, k4IdsToUrlString } from '../../../../../utils/util';
import { FreeSoloCreateOption } from './CreateSiteDropdown';
import SingleLineDisplay from '../../components/SingleLineDisplay';
import change_license_icon from '../../../../../asset/image/change_license_icon.svg';
import move_site_icon from '../../../../../asset/image/move_site_icon.svg';
import router_icon_new from '../../../../../asset/image/router_icon_new.svg';
import lines_dotted from '../../../../../asset/image/line-dotted.svg';
import warehouse_icon from '../../../../../asset/image/warehouse-into-outline.svg';
import router_list_icon from '../../../../../asset/image/router_list_icon.svg';
import organization_icon from '../../../../../asset/image/organization_icon.svg';
import dashboard_admin_site from '../../../../../asset/image/dashicons_admin-site.svg';
import OptionSelector from './OptionSelector';
import SummaryWithIcons from './SummaryWithIcons';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import TextField from "@mui/material/TextField";
import { parseISO, addDays, isValid, differenceInDays, format, differenceInMonths, addMonths, isAfter, startOfDay } from "date-fns";
import pause_filled from '../../../../../asset/image/pause-filled.svg';
import resume_filled from '../../../../../asset/image/resume-rounded.svg';
import InfoNote from '../../components/InfoNote/InfoNote';
import InfoAlert from '../../components/InfoAlert/InfoAlert';
import PauseProgressBar from '../../components/PauseProgressBar/PauseProgressBar';
import IconMessage from '../../components/IconMessage/IconMessage';
import hugeicons_license from '../../../../../asset/image/hugeicons_license.svg';
import hugeicons_license_pause from '../../../../../asset/image/hugeicons_license_pause.svg';
import moment from 'moment';
import { DEREGISTRATION_SYNC, DEVICE_MOVEMENT_SYNC, POLL_INTERVAL, SITE_MOVEMENT_SYNC, CHANGE_LICENSE_SYNC, PAUSE_LICENSE_SYNC, CANCEL_PAUSE_LICENSE_SYNC, RESUME_LICENSE_SYNC, CANCEL_DE_REGISTER_SYNC, TRANSFER_LICENSE_SYNC } from '../../../../../utils/constants';

const TransferTab = (props) => {
  const { setOpen, row, refreshIconClicked, getDeviceLinkStatusData, deviceLinkStatusLoading, getDeRegisterDeviceData, moveDeviceToWarehouse, moveToWarehouseData, upgradeInventoryLicense, inventoryUpgradeLicense, getSwapModeData, createVessel, createVesselData, getDeviceTransferData, inventoryChangeGroup, inventoryChangeGroupData, fetchResources, fetchResourcesData, getDeviceTransfer,
    getDeRegisterDeviceLoading, setInventoryAssignDeviceToWarehouse, setUpgradeInventoryLicenseLoading, getSwapModeLoading, inventoryListingLoading, getDeviceTransferLoading, getCancelDeRegisterData, setCancelDeRegister, getCancelDeRegister, setLicenseTypesLoading, trackInventorySyncStatusData, trackInventoryStatusData, location, history, getPauseLicenseData, setPauseLicense, getPauseLicense, getResumeLicenseData, setResumeLicense, getResumeLicense, getWHProdGPDeviceListData, getWHProdGPDeviceList, setWHProdGPDeviceListLoading,
    getTransferLicenseData, getTransferLicense, setTransferLicenseLoading, getOrganisationInfo, getDpInfo, setDpInfoLoading, getCancelPauseLicenseData, getCancelPauseLicense, setCancelPauseLicenseLoading, onLicenseChangeSuccess
  } = props;
  const dispatch = useDispatch();
  let _q = getDecodeURI(location?.search);

  const [vessels, setVessels] = useState<any>();
  const [openPopup, setOpenPopup] = useState(false);
  const [pausePopup, setPausePopup] = useState(false);
  const [resumePopup, setResumePopup] = useState(false);
  const [confirmPauseResumePopup, setConfirmPauseResumePopup] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string>('site_transfer');
  const [changedOuInfo, setChangedOuInfo] = useState<any>({ name: row['dpname'], id: row['dpId'] });

  const [selectedLicense, setSelectedLicense] = useState<any>({});
  const [selectedTerm, setSelectedTerm] = useState<any>({});
  const [upgradeLicensePayload, setUpgradeLicensePayload] = useState<any>({});
  const [selectedRouter, setSelectedRouter] = useState<any>({});

  const [deRegistrationReasons, setDeRegistrationResons] = useState<any>([]);
  const [deleteSiteEnabled, setDeleteSiteEabled] = useState<boolean>(false);
  const [selectedDeRegistrationReason, setSelectedDeRegistrationReason] = useState<string>();
  const [selectedDeRegistrationReasonInput, setSelectedDeRegistrationReasonInput] = useState<string>('');
  const [dialogueMessage, setDialogueMessage] = useState('');

  const [checkInputValue, setCheckInputValue] = useState(false);
  const [siteValue, setSiteValue] = useState<any>({});
  const [value, setValue] = useState<any>(null);
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [radioValue, setRadioValue] = useState("");
  const [cancelDeRegReason, setCancelDeRegReason] = useState('');
  const [reasonError, setReasonError] = useState("");
  const [pauseDate, setPauseDate] = useState<any>(row?.['pausedOn']);
  const [resumeDate, setResumeDate] = useState<any>(row?.['resumeDate'] ?? '');
  const [predefinedDates, setPredefinedDates] = useState<any>()
  const [devicesList, setDevicesList] = useState<any>([]);
  const [selectedDevice, setSelectedDevice] = useState<any>('');
  const [isAllowed, setIsAllowed] = useState<any>({});
  const [isChangeSchedule, setIsChangeSchedule] = useState<boolean>(false);
  const [errorCode, setErrorCode] = useState<number | null>(null);
  const [syncInprogress, setSyncInprogress] = useState(false);
  const [requestType, setRequestType] = useState<any>(null);
  const [deleteSite, setDeleteSite]=useState<boolean>(false);
  const [isResumeNow, setIsResumeNow]=useState<boolean>(false);

  const isTodayOrFuture = (dateStr: string) => {
    if (!dateStr) return false;

    const date = moment(dateStr, "YYYY-MM-DD HH:mm:ss").startOf("day");
    const today = moment().startOf("day");

    return date.isSameOrAfter(today);
  };

  useEffect(() => {
    const _loggedInUser: any = getDataFromLocalStorage("loggedInUser");
    if (_loggedInUser) {
      const loggedInUser = JSON.parse(_loggedInUser);
      if (loggedInUser?.data?.user) {
        setContactName(`${loggedInUser?.data?.user?.name?.givenName} ${loggedInUser?.data?.user?.name?.familyName}`);
        setContactEmail(`${loggedInUser?.data?.user.userName}`)
      }
    }
    getOrganisationInfo(row?.dpname);
  }, []);

  const handleOu = (ou: any) => {
    setChangedOuInfo(ou);
    fetchResources(ou.name, 0, 500, '', '');
  }

  useEffect(() => {
    if (!_.isEmpty(fetchResourcesData)) {
      let resourceRecords = fetchResourcesData?.locations;
      if (resourceRecords && Array.isArray(resourceRecords)) {
        let resourceSort = resourceRecords.sort((a, b) => a.name - b.name);
        const list = resourceSort?.map((vs) => {
          return { label: vs.name, id: vs.id }
        })
        setVessels(list);
      } else {
        setVessels([]);
      }
      dispatch({ type: FETCH_OU_RESOURCES, payload: {} })
    }
  }, [fetchResourcesData]);

  useEffect(() => {
    if (refreshIconClicked) {
      getDeviceLinkStatusData(row['k4Id'], row['deviceId']);
    }
  }, [refreshIconClicked])

  const handleWarehouseClick = () => {
      const payload = { moveToDP: true, deRegReason: "", validated: false };
      moveDeviceToWarehouse(row['deviceId'], payload);
  }

  const handleChangeLicense = () => {
    const payload = {
      did: row['deviceId'],
      licenseFrom: row?.licenseTier,
      licenseTo: selectedLicense?.value,
      termFrom: row.termValue,
      termTo: selectedTerm?.value,
      licenseAliasFrom: row?.licenseTier,
      licenseAliasTo: selectedLicense?.licenseTier,
      validated: dialogueMessage ? true : undefined
    }
    setUpgradeLicensePayload(payload);
    upgradeInventoryLicense(payload, row?.['k4Id']);
    _q.action = 'change_license';
    history.push({ pathname: location.pathname, search: `?${getEncodedURI(_q)}` });
  };

  const handlePauseLicense = () => {
    let payload: any = {
      deviceId: row.deviceId,
      k4Id: row.k4Id,
      validated: false,
    };

    if (dialogueMessage) {
      payload = {
        ...payload,
        pauseDate: moment(pauseDate)?.format('YYYY-MM-DD'),
        resumeDate: row['termDisplay'].includes('Year') ? moment(resumeDate)?.format('YYYY-MM-DD') : undefined,
        validated: true,
      };
    }
    getPauseLicenseData(payload);
  }

  const formatToDate = (date) => {
    if (!date) return null;

    // If it's already a Date object → return as is
    if (date instanceof Date) return date;

    // If API sends YYYY-MM-DD → convert
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [year, month, day] = date.split("-");
      return new Date(Number(year), Number(month) - 1, Number(day));
    }

    // Fallback for any other ISO string format
    return new Date(date);
  };

  useEffect(() => {
    if (!_.isEmpty(moveToWarehouseData)) {
      const res = moveToWarehouseData;
      if (res?.message && (res?.error_code == 10011 || res?.error_code == 10035 || res?.error_code == 10015 || res?.error_code == 10055 || res?.error_code == 10056)) {
        const deRegReasons = res.hasOwnProperty('data') && !_.isEmpty(res?.data) ? res?.data : [];
        setDeRegistrationResons([...deRegReasons, 'Other']);
        setDeleteSiteEabled(moveToWarehouseData?.delete_site);
        setOpenPopup(true);
        setWarningModal(false);
        setDialogueMessage(res.message);
      } else if (res.hasOwnProperty("status") && res.status == 1) {
        if (row?.['deviceId']?.startsWith('RS') || row?.['deviceId']?.startsWith('RM')) {
          getDeRegisterDeviceData(row?.['deviceId'], row?.['licenseTier'] == 'T103' ? 'ap' : 'router')
        }
      }
    }
  }, [moveToWarehouseData])

  useEffect(() => {
    if (!_.isEmpty(inventoryUpgradeLicense)) {
      const res = inventoryUpgradeLicense;
      if (res?.message && (res?.error_code == 14013 || res?.error_code == 14014 || res?.error_code == 14015 || res?.error_code == 14016 || res?.error_code == 14019 || res?.error_code == 14029)) {
        setOpenPopup(true);
        setWarningModal(false);
        setDialogueMessage(res.message);
        setErrorCode(res.error_code);
      } else if (res.hasOwnProperty("status") && res.status == 1) {
        if (row?.['deviceId']?.startsWith('RS') || row?.['deviceId']?.startsWith('RM')) {
          if (upgradeLicensePayload?.licenseAliasTo == 'T103') {
            getSwapModeData(row?.['deviceId'], 'ap', selectedRouter?.router_did)
          } else if (upgradeLicensePayload?.licenseAliasFrom == 'T103') {
            getSwapModeData(row?.['deviceId'], 'router')
          }
        }
        setOpenPopup(false);
        handleResetValues();
        onLicenseChangeSuccess?.();
      }
      dispatch({ type: GET_UPGRADE_INVENTORY_LICENSE, payload: {} })
    }
  }, [inventoryUpgradeLicense])

  const normalizeDate = (date) => {
    if (!date) return null;

    if (date instanceof Date) return date;

    // API format YYYY-MM-DD → safe conversion
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [y, m, d] = date.split("-");
      return new Date(Number(y), Number(m) - 1, Number(d));
    }

    return new Date(date);
  };

  
  useEffect(() => {
    if (!_.isEmpty(getPauseLicense)) {
      const res = getPauseLicense;
      if (res?.message && (res?.error_code == 12000 || res?.error_code == 11035 || res?.error_code == 11034)) {
        setWarningModal(false);
        setDialogueMessage(res.message);
        setPredefinedDates({pauseDate: normalizeDate(res?.dates?.pauseDate), maxResumeDate: normalizeDate(res?.dates?.maxResumeDate), pauseBalance: res?.dates?.pauseBalance});
        setPauseDate(normalizeDate(res?.dates?.pauseDate));
        setResumeDate(normalizeDate(res?.dates?.maxResumeDate));
        setErrorCode(res?.error_code);
      } else if (res.hasOwnProperty("status") && res.status == 1) {
        setOpen(false);
        setDialogueMessage('');
      } else {
        setOpen(false);
        setDialogueMessage('');
      }
      dispatch({ type: GET_PAUSE_LICENSE, payload: {} })
    }
    if(!_.isEmpty(getCancelPauseLicense)) {
      const res = getCancelPauseLicense;
      if(res.hasOwnProperty("status") && res.status == 1) {
        setPausePopup(false);
      }
      setOpen(false);
      dispatch({ type: GET_CANCEL_PAUSE_LICENSE, payload: {} })
    }
    if(!_.isEmpty(getResumeLicense)) {
      const res = getResumeLicense;
      if(res.hasOwnProperty("status") && res.status == 1) {
        if(res.error_code != 18014){
          setPausePopup(false);
          setOpen(false);
        }
        else{
          setPredefinedDates(prev => ({
            ...prev,
            maxResumeDate: normalizeDate(res?.dates?.maxResumeDate)
          }));
        }
      }
      dispatch({ type: GET_RESUME_LICENSE, payload: {} })
    }
  }, [getPauseLicense, getCancelPauseLicense, getResumeLicense]);

  const handleDeRegistrationReason = (e, newValue, field) => {
    if (field == 'text') {
      setSelectedDeRegistrationReasonInput(newValue);
    } else {
      setSelectedDeRegistrationReason(newValue);
      if (newValue !== 'Other') {
        setSelectedDeRegistrationReasonInput('');
      }
    }
  }

  const handleCreateAndAssignInventory = (siteValue) => {
    if (siteValue) {
      let payload = {
        "vesselName": siteValue,
        "contactName": contactName,
        "contactEmail": contactEmail,
        "k4DpId": row?.dpId,
        "source": "SPORT"
      }
      createVessel(contactEmail, payload)
    }
  }

  useEffect(() => {
    if (!_.isEmpty(createVesselData)) {
      if (createVesselData.hasOwnProperty("status") && createVesselData.status == 1) {
        setSiteValue({ label: createVesselData?.data?.name, id: createVesselData?.data?.k4Id })
      }
      dispatch({ type: CREATE_AND_ASSIGN_INVENTORY, payload: {} })
    }
  }, [createVesselData]);

  useEffect(() => {
    if (!_.isEmpty(inventoryChangeGroupData) && inventoryChangeGroupData?.status == 1) {
      setOpen(false);
      setChangedOuInfo({});
      dispatch({ type: INVENTORY_CHANGE_GROUP, payload: {} })
    }
  }, [inventoryChangeGroupData]);

  useEffect(() => {
    if (!_.isEmpty(getDeviceTransfer) && getDeviceTransfer?.status == 1) {
      setOpen(false);
      dispatch({ type: GET_DEVICE_TRANSFER, payload: {} })
      setSiteValue({});
    }
    if (!_.isEmpty(getCancelDeRegister)) {
      setOpen(false);
      dispatch({ type: GET_CANCEL_DE_REGISTER, payload: {} })
      setCancelDeRegReason('');
      setReasonError('');
    }
  }, [getDeviceTransfer, getCancelDeRegister])

  const getRemainingDuration = (expiryDateStr) => {
    if (!expiryDateStr) return { days: 0, formatted: "0 days" };

    const expiry = startOfDay(parseISO(expiryDateStr));
    const today = startOfDay(new Date());

    let totalDays = differenceInDays(expiry, today);
    if (isAfter(expiry, today) || totalDays === 0) {
      totalDays += 1;
    }

    const months: any = Math.floor(totalDays / 30);
    const days: any = totalDays % 30;

    const formattedParts: any = [];
    if (months > 0) formattedParts.push(`${months} month${months > 1 ? "s" : ""}`);
    if (days > 0) formattedParts.push(`${days} day${days > 1 ? "s" : ""}`);

    return {
      days: totalDays,
      formatted: formattedParts.join(" ") || "0 days",
    };
  };

  const deviceTransferWarning = () => (
    <SummaryWithIcons
      icons={[<img src={router_icon_new} />, <img src={lines_dotted} />, <img src={organization_icon} />]}
      summaryItems={[
        { label: "Device", value: row['deviceName'] },
        { label: "From", value: row['dpname'] },
        { label: "To", value: changedOuInfo?.['name'] },
      ]}
      description="Historical usage data from this device will be transferred to the new site and organization."
    />
  );

  const siteTransferWarning = () => (
    <SummaryWithIcons
      icons={[<img src={dashboard_admin_site} />, <img src={router_list_icon} />, <img src={lines_dotted} />, <img src={organization_icon} />]}
      summaryItems={[
        { label: "Device", value: row['deviceName'] },
        { label: "From", value: row['dpname'] },
        { label: "To", value: changedOuInfo?.['name'] },
      ]}
      description="All usage data will be transferred to the new organization."
    />
  );

  const warehouseWarning = () => (
    <SummaryWithIcons
      icons={[<img src={router_icon_new} />, <img src={lines_dotted} />, <img src={warehouse_icon} />]}
      summaryItems={[
        { label: "Device", value: row['deviceName'] },
        { label: "From", value: row['dpname'] },
        { label: "To", value: changedOuInfo?.['name'] },
      ]}
      description="Historical usage data from this device will NOT be transferred to the new site and organization."
    />
  );

  const cancelDeRegisterWarning = () => {
    return <div className='value-text'>
      You are about to cancel the DeRegistration ?
    </div>
  }

  const cancelTransferLicenseWarning = () => {
    return (
      <>
        <div className="value-text">
          You are about to transfer the license from {row['deviceId']} to {selectedDevice}?
        </div>
        <br />
        <span className="value-text">Remaining term will be {getRemainingDuration(row?.license_expiry_date)?.formatted} for device {selectedDevice}.</span>
      </>
    );
  };

  const handleResetValues = () => {
    setSelectedLicense({});
    setSelectedTerm({});
    setSelectedRouter({});
    setUpgradeLicensePayload({});
    setSiteValue({});
    setValue(null);
    setDeRegistrationResons([]);
    setDeleteSiteEabled(false);
    setSelectedDeRegistrationReason('');
    setSelectedDeRegistrationReasonInput('');
    setDialogueMessage('');
    setRadioValue('');
    setSelectedOption('');
    setCancelDeRegReason('');
    setReasonError('');
    setPredefinedDates(null);
    setPauseDate(normalizeDate(row?.['pausedOn']));
    setResumeDate(normalizeDate(row?.['resumeDate']));
    setDevicesList([]);
    setSelectedDevice('');
    setErrorCode(null);
    dispatch({type: TRACK_INVENTORY_SYNC_DATA, payload: {}})
  }

  const handleSaveDisabled = () => {
    switch (radioValue) {
      case 'device_transfer':
        return !siteValue?.label;

      case 'warehouse':
        if (!deRegistrationReasons || deRegistrationReasons.length === 0) return false;
        if (!selectedDeRegistrationReason) return true;
        if (selectedDeRegistrationReason === 'Other') {
          const input = selectedDeRegistrationReasonInput?.trim();
          return !input || input.length > 50;
        }
        return false;

      case 'change_license':
        return !(
          selectedLicense?.label &&
          selectedTerm?.label &&
          (selectedLicense?.licenseTier !== 'T103' || selectedRouter?.deviceAlias)
        );

      case "pause_license":
        return dialogueMessage ? !(pauseDate && resumeDate) : false;

      case 'cancel-de-reg':
        return !!reasonError || !cancelDeRegReason.trim();

      case 'transfer_license':
        return !selectedDevice;

      default:
        return false;
    }
  };

  const getWarningInfo = (option) => {
    switch (option) {
      case 'warehouse':
        return warehouseWarning();
      case 'site_transfer':
        return siteTransferWarning();
      case 'device_transfer':
        return deviceTransferWarning();
      case 'cancel-de-reg':
        return cancelDeRegisterWarning();
      case 'transfer_license':
        return cancelTransferLicenseWarning();
      case 'cancel_pause_license':
      default:
        return null;
    }
  };

  const handleConfirm = () => {
    _q.action = radioValue;
    if(radioValue == 'device_transfer') {
      _q.newSiteId = siteValue?.id;
    }
    if(radioValue == 'transfer_license') {
      _q.toDeviceId = selectedDevice?.split(' (')?.[0];
    }
    history.push({ pathname: location.pathname, search: `?${getEncodedURI(_q)}` });

    switch (radioValue) {
      case 'warehouse':
        const payload = !_.isEmpty(deRegistrationReasons) ? { moveToDP: true, validated: true, deRegReason: selectedDeRegistrationReasonInput ? selectedDeRegistrationReasonInput : selectedDeRegistrationReason != 'Other' ? selectedDeRegistrationReason : null, ...(deleteSiteEnabled && {delete_site: deleteSite}) } : { moveToDP: true, deRegReason: "", validated: false, ...(deleteSiteEnabled && {delete_site: deleteSite}) };
        moveDeviceToWarehouse(row['deviceId'], payload);
        break;

      // case 'change_license':
      //   upgradeInventoryLicense({ ...upgradeLicensePayload, validated: true });
      //   break;

      case 'site_transfer':
        inventoryChangeGroup(row?.['k4Id'], changedOuInfo.id);
        break;

      case 'device_transfer':
        getDeviceTransferData(row?.['deviceId'], siteValue?.id, row?.['k4Id']);
        break;

      case 'cancel-de-reg':
        getCancelDeRegisterData(row?.['deviceId'], cancelDeRegReason);
        break;

      case 'transfer_license':
        getTransferLicenseData(row?.['deviceId'], selectedDevice?.split(' (')[0], dialogueMessage ? true : false, row?.['k4Id']);
        break;

      default:
        break;
    }
  };

  const handleRadioChange = (e) => {
    setRadioValue(e.target.value);
    if(e.target.value == 'transfer_license') {
      getWHProdGPDeviceListData(row?.['dpId'], row?.['deviceId']);
    }
  };

  useEffect(() => {
    const options = getRadioOptions(selectedOption);
    if (options.length > 0) {
      setRadioValue(options[0].value);
    }
  }, [selectedOption]);

  const getRadioOptions = (type) => {
    if (type === "move_device") {
      return [
        { value: "device_transfer", label: "Move Device Only (Keep Existing Site)" },
        { value: "site_transfer", label: "Move Site and All Devices" },
        !isTodayOrFuture(row?.['deRegisteredDate']) && { value: "warehouse", label: "Move Device to Warehouse" },
      ].filter(Boolean) as { value: string; label: string }[];
    }

    if (type === "change_license") {
      return [
        { value: "change_license", label: "Upgrade License" },
        hasLicensePermission('TransferLicenseRW') && isAllowed?.isTransferAllowed && row?.['licenseType'] == 'Production' && row?.license_expiry_date && moment(row?.license_expiry_date).startOf("day").isSameOrAfter(moment().startOf("day")) && { value: "transfer_license", label: "Transfer License" },
      ].filter(Boolean) as { value: string; label: string }[];
    }

    if(type == 'cancel-de-reg') {
      return [
        { value: "cancel-de-reg", label: "Cancel DeRegistration" }
      ];
    }

    return [];
  };

  const radioGroup = {
    columns: [
      {
        component: (
          <OptionSelector
            value={radioValue}
            onChange={handleRadioChange}
            options={getRadioOptions(selectedOption)}
          />
        ),
        gridSize: 12,
      },
    ],
  };

  const getValidDate = (date) => {
    if (!date) return undefined;
    const parsed = typeof date === "string" ? parseISO(date) : date;
    return isValid(parsed) ? parsed : undefined;
  };
  const handleCheckBoxClick = () => {
      setDeleteSite(!deleteSite);
  }
  const getLayout = () => {
    const layout: any[] = [radioGroup];

    if (radioValue === "change_license") {
      layout.push(
        {
          columns: [
            {
              component: (
                <ChangeLicense
                  row={row}
                  selectedRouter={selectedRouter}
                  setSelectedRouter={setSelectedRouter}
                  setUpgradeLicensePayload={setUpgradeLicensePayload}
                  selectedLicense={selectedLicense}
                  setSelectedLicense={setSelectedLicense}
                  selectedTerm={selectedTerm}
                  setSelectedTerm={setSelectedTerm}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <SummaryWithIcons
                  description={[
                    `Upgrading license from ${row['tierAlias']} to ${selectedLicense?.label}`,
                    "Change takes effect after the device is rebooted.",
                    "The remaining term will be charged at the new license rate, prorated for the days left."
                  ]}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: dialogueMessage && <div className='value-text-new margin-top-10'>{dialogueMessage}</div>,
              gridSize: 12,
            },
          ],
        }
      );
    } else if (radioValue === "transfer_license") {
      layout.push(
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="From Device"
                  value={row['deviceId']}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="To Device"
                  isDropdown={true}
                  dropdownOptions={devicesList?.map((device) => device?.deviceId)}
                  value={selectedDevice}
                  onChange={(e) => {setSelectedDevice(e.target.value); setDialogueMessage('')}}
                  placeholder='Select Device'
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: dialogueMessage && <div className='value-text-new margin-top-10'>{dialogueMessage}</div>,
              gridSize: 12,
            },
          ],
        }
      );
    } else if (radioValue === "device_transfer") {
      layout.push(
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="From Organization / Site"
                  value={`${row['dpname']} / ${row['name']}`}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="To Organization"
                  customComponent={
                    <div style={{ width: '100%', maxWidth: '438px' }}>
                      <DP_Dropdown
                        isReports={false}
                        setOu={handleOu}
                        height="28px"
                        width="100% !important"
                        dropdownMenuWidth='424px'
                      />
                    </div>
                  }
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="To Site"
                  customComponent={
                    <div style={{ width: '100%', maxWidth: '438px' }}>
                      <FreeSoloCreateOption
                        vesselNames={vessels?.length > 0 ? vessels : []}
                        check={setCheckInputValue}
                        setSiteValue={setSiteValue}
                        value={value}
                        setValue={setValue}
                        handleCreateAndAssignInventory={handleCreateAndAssignInventory}
                        width='425px'
                      />
                    </div>
                  }
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Device"
                  value={row['deviceName']}
                />
              ),
              gridSize: 12,
            },
          ],
        }
      );
    } else if (radioValue === "warehouse") {
      layout.push(
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Organization"
                  value={row['dpname']}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Site"
                  value={row['name']}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Device"
                  value={row['deviceName']}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: dialogueMessage && <div className='internetr-status-header-paddingBottom'><LabelValueDisplay label='' value={dialogueMessage} /></div>,
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: !_.isEmpty(deRegistrationReasons) && (
                <>
                  <LabelValueDisplay
                    label=""
                    isDropdown
                    placeholder="Select Reason"
                    dropdownOptions={deRegistrationReasons}
                    value={selectedDeRegistrationReason}
                    onChange={(e) => handleDeRegistrationReason(e, e.target.value, 'dropdown')}
                  />
                  <br />
                  {selectedDeRegistrationReason === 'Other' && (
                    <LabelValueDisplay
                      label="Other Reason"
                      isInput
                      placeholder="Enter Reason"
                      value={selectedDeRegistrationReasonInput}
                      onChange={(e) => handleDeRegistrationReason(e, e.target.value, 'text')}
                    />
                  )}
                  {selectedDeRegistrationReasonInput.length > 50 && (
                    <span id="site-error-message">Maximum 50 characters allowed.</span>
                  )}
                </>
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: deleteSiteEnabled && <div className='rem-conn-all'>
                <LabelValueDisplay 
                  label='Delete Site'
                  isCheckBox={true}
                  isChecked={deleteSite}
                  handleCheckBoxClick={handleCheckBoxClick}
                />
                </div>,
              gridSize: 12,
            },
          ],
        },
      );
    } else if (radioValue === "cancel-de-reg") {
      layout.push(
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Organization"
                  value={row['dpname']}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Site"
                  value={row['name']}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Device"
                  value={row['deviceName']}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: <div className='rem-conn-all'><LabelValueDisplay label='' value={'Please provide a reason to cancel the de-registration.'} /></div>,
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component:
                (
                  <LabelValueDisplay
                    label="Reason"
                    isInput
                    placeholder="Enter Reason"
                    value={cancelDeRegReason}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCancelDeRegReason(value);
                      if (!/^[a-zA-Z0-9\s]*$/.test(value)) {
                        setReasonError("Only letters, numbers, and spaces are allowed");
                      } else if (value.trim() === "") {
                        setReasonError("Reason is required");
                      } else {
                        setReasonError("");
                      }
                    }}
                    error={reasonError}
                  />
                ),
              gridSize: 12,
            },
          ],
        }
      );
    } else if(radioValue == 'site_transfer') {
      layout.push(
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="From Organization"
                  value={row['dpname']}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="To Organization"
                  customComponent={
                    <div style={{ width: '100%', maxWidth: '438px' }}>
                      <DP_Dropdown
                        isReports={false}
                        setOu={setChangedOuInfo}
                        height="28px"
                        width="100% !important"
                        dropdownMenuWidth='424px'
                      />
                    </div>
                  }
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Site"
                  value={row['name']}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Device"
                  value='All Devices'
                />
              ),
              gridSize: 12,
            },
          ],
        }
      );
    }

    return layout;
  };

  const addDays = (date: Date, days: number) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };

  const subtractDays = (date: Date, days: number) => {
    const d = new Date(date);
    d.setDate(d.getDate() - days);
    return d;
  };

  const isFuturePauseDate = (value: string) => {
    if (!value) return false;

    const formatted = value.split(" ")[0];
    const dateObj = new Date(formatted);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    dateObj.setHours(0, 0, 0, 0);

    return dateObj > today;
  };

  const isTodayOrFuturePauseDate = (value: string) => {
    if (!value) return false;

    const formatted = value.split(" ")[0];
    const dateObj = new Date(formatted);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    dateObj.setHours(0, 0, 0, 0);

    return dateObj >= today;
  };

  
  const handlePauseDateChange = (e) => {
    const FIXED_DIFF = 90;
    const newPauseDate = new Date(e.target.value);

    const newResumeDate = addDays(newPauseDate, FIXED_DIFF);

    setPauseDate(newPauseDate);
    // setResumeDate(newResumeDate);

  };

  const handleResumeDateChange = (e) => {
    const newResumeDate = new Date(e.target.value);
    setResumeDate(newResumeDate);
  };

  const formatDate = (input) => {
    const date = input instanceof Date ? input : new Date(input);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const getPauseLicenseLayout = () => {
    const layout: any[] = [];

    if (selectedOption === 'pause_license') {
      layout.push(
        {
          columns: [
            {
              component: (
                <InfoNote
                  showIcon
                  messages={[
                    row?.['termDisplay']?.includes('Year') && { text: "Select dates to schedule Pause and Resumption." },
                    {
                      text: "Details on charges during pause period and maximum pause duration are available in the ",
                      linkText: "Terms & Conditions.",
                      linkUrl: "/",
                    },
                  ].filter(Boolean)}
                />
              ),
              gridSize: 6,
            },
            row?.['termDisplay']?.includes('Year') && {
              component: (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    border: "1px solid rgba(235, 235, 235, 1)",
                    borderRadius: "8px",
                    marginBottom: "-18px",
                    padding: "10px"
                  }}
                >
                  <LabelValueDisplay
                    label="Pause Date"
                    isDate={true}
                    value={pauseDate}
                    onChange={handlePauseDateChange}
                    placeholder="MM/DD/YYYY"
                    minDate={predefinedDates?.pauseDate}
                    maxDate={subtractDays(resumeDate, 1)}
                    disabled={errorCode == 11035}
                  />
                  <LabelValueDisplay
                    label="Resume Date"
                    isDate={true}
                    value={resumeDate? resumeDate : null}
                    onChange={handleResumeDateChange}
                    placeholder="MM/DD/YYYY"
                    minDate={addDays(pauseDate, 1)}
                    maxDate={predefinedDates?.maxResumeDate}
                    disabled={errorCode == 11035}
                  />
                  {enablePauseOption && <div className='value-text-new'>{`Pause Balance: ${predefinedDates?.pauseBalance ?? 0} Days`}</div>}
                  {resumePopup && <PauseProgressBar
                    label="Paused Month(s)"
                    current={1}
                    total={3}
                    unit="" // or "Months"
                    color="#4caf50"
                  />}
                </div>
              ),
              gridSize: 6
            },
            row?.['termDisplay']?.includes('Month') && {
              component: (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    border: "1px solid rgba(235, 235, 235, 1)",
                    borderRadius: "8px",
                    marginBottom: "-18px",
                    padding: "10px",
                    minHeight: '112px'
                  }}
                >
                  <LabelValueDisplay
                    label="Pause Date"
                    isDate={true}
                    value={pauseDate}
                    onChange={handlePauseDateChange}
                    placeholder="MM/DD/YYYY"
                    minDate={predefinedDates?.pauseDate}
                    disabled={errorCode == 11035}
                  />
                </div>
              ),
              gridSize: 6
            }
          ].filter(Boolean),
        },
        {
          columns: [
            {
              component: dialogueMessage && (errorCode == 11035 || errorCode == 11034) && <div className='internetr-status-header-paddingBottom'><LabelValueDisplay label='' value={dialogueMessage} isHtml={true} /></div>,
              gridSize: 12,
            },
          ],
        },
      );
    }

    if (selectedOption === 'cancel_pause') {
      layout.push(
        {
          columns: [
            {
              component: (
                <LabelValueDisplay label="Pause Start On" value={formatToReadable(row?.['pausedOn'])} />
              ),
              gridSize: 6
            },
          ],
        },
        {
          columns: row?.['termDisplay']?.includes('Year') ? [
            {
              component: (
                <LabelValueDisplay label="Resume Date" value={formatToReadable(row?.['resumeDate'])} />
              ),
              gridSize: 6
            },
          ] : [],
        },
        {
          columns: [
            {
              component: (
                <InfoAlert>
                  Pause request will be cancelled and service will resume per the{" "}
                  <a href="#" className="info-alert-link">
                    Terms & Conditions.
                  </a>
                </InfoAlert>
              ),
              gridSize: 12
            },
          ],
        }
      );
    }

    if (selectedOption === 'resume_license') {
      layout.push({
        columns: [
          {
            component: (
              <LabelValueDisplay label="Pause Since" value={formatToReadable(row['pausedOn'])} />
            ),
            gridSize: 6
          },
        ],
      },
        {
          columns: row?.['termDisplay']?.includes('Year') ? [
            {
              component: (
                <LabelValueDisplay label="Resume Date" value={formatToReadable(row['resumeDate'])} />
              ),
              gridSize: 6
            },
          ] : [],
        },
        {
          columns: row?.['termDisplay']?.includes('Year') ? [
            {
              component: (
                <PauseProgressBar
                  label="Pause Progress"
                  current={getPauseProgress(row?.['pausedOn'], row?.['resumeDate'])?.current}
                  total={getPauseProgress(row?.['pausedOn'], row?.['resumeDate'])?.total}
                  unit="Days"
                  color="#f6b500"
                />
              ),
              gridSize: 12
            },
          ] : [],
        },
        {
          columns: [
            {
              component: (
                <Box height="10px" />
              ),
              gridSize: 12,
            }
          ]
        },
        {
          columns: [
            {
              component: (
                <InfoAlert>
                  Click Change resume date to change the resume date, if it is already paused Click Resume Now to cancel the scheduled resume date and resume immediately per{" "}
                  <a href="#" className="info-alert-link">
                    Terms & Conditions.
                  </a>
                </InfoAlert>
              ),
              gridSize: 12
            },
          ],
        }
      );
    }

    return layout;
  };

  const getResumeLicenseLayout = () => {
    const layout: any[] = [];

    if (selectedOption === 'resume_license') {
      layout.push(
        {
          columns: [
            {
              component: (
                <InfoNote
                  showIcon
                  messages={[
                    row?.['termDisplay']?.includes('Year') && { text: "Select dates to schedule Pause and Resumption." },
                    {
                      text: "Details on charges during pause period and maximum pause duration are available in the ",
                      linkText: "Terms & Conditions.",
                      linkUrl: "/",
                    },
                  ].filter(Boolean)}
                />
              ),
              gridSize: 6,
            },
            {
              component: (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    border: "1px solid rgba(235, 235, 235, 1)",
                    borderRadius: "8px",
                    marginBottom: "-18px",
                    padding: "10px"
                  }}
                >
                  <LabelValueDisplay
                    label="Pause Date"
                    isDate={true}
                    value={pauseDate}
                    onChange={handlePauseDateChange}
                    placeholder="MM/DD/YYYY"
                    minDate={predefinedDates?.pauseDate}
                    // maxDate={subtractDays(resumeDate, 1)}
                    disabled={true}
                  />
                  <LabelValueDisplay
                    label="Resume Date"
                    isDate={true}
                    value={resumeDate? resumeDate : new Date(
                      Math.max(
                        addDays(pauseDate, 1).getTime(),
                        new Date().getTime()
                      )
                    )}
                    onChange={handleResumeDateChange}
                    placeholder="MM/DD/YYYY"
                    minDate={addDays(pauseDate, 1)}
                    maxDate={predefinedDates?.maxResumeDate}
                    disabled={false}
                  />
                  {enablePauseOption && <div className='value-text-new'>{`Pause Balance: ${predefinedDates?.pauseBalance ?? 0} Days`}</div>}
                  {resumePopup && <PauseProgressBar
                    label="Paused Month(s)"
                    current={1}
                    total={3}
                    unit="" // or "Months"
                    color="#4caf50"
                  />}
                </div>
              ),
              gridSize: 6
            },
            ].filter(Boolean),
        },
        {
          columns: [
            {
              component: dialogueMessage && (errorCode == 11035 || errorCode == 11034) && <div className='internetr-status-header-paddingBottom'><LabelValueDisplay label='' value={dialogueMessage} isHtml={true} /></div>,
              gridSize: 12,
            },
          ],
        },
      );
    }
    return layout;
  }

  const getPauseLicenseConfirmLayout = () => {
    const layout: any[] = [];
    if (resumePopup || selectedOption === 'resume_license') {
      layout.push(
        {
          columns: [
            {
              component: (
                <IconMessage
                  icon={hugeicons_license_pause}
                  message={`The license will be resumed on ${isResumeNow ? new Date()?.toISOString()?.split('T')[0] : formatDate(resumeDate)}.`}
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <InfoAlert>
                  Check the <a href="#" className="info-alert-link">Terms & Conditions</a> for any fees or charges incurred by this action.
                </InfoAlert>
              ),
              gridSize: 12,
            }
          ],
        }
      );
    }
    else if (selectedOption === 'pause_license') {
      layout.push(
        {
          columns: [
            {
              component: (
                <IconMessage
                  icon={hugeicons_license}
                  message="Pause scheduled for"
                  boldText={pauseDate ? format(pauseDate, "dd MMM yyyy") : ""}
                />
              ),
              gridSize: 12,
            }
          ],
        });
    }
    return layout;
  }

  const handleChangePauseSchedule = () => {
    setPausePopup(true);
    if (selectedOption == 'resume_license') {
      if(enableCancelPauseOption){
        setPausePopup(false) 
        handleResetValues()
      }
      else{
        setResumePopup(true);
        setPausePopup(false);
        // call the resumelicense api to get the maxresume date
        getResumeLicenseData(row?.['deviceId'], formatDate(resumeDate));
      }
    }
    if (selectedOption == 'cancel_pause') {
      setPausePopup(false) 
      handleResetValues()
    }
    setPauseDate(normalizeDate(row?.['pausedOn']));
    setResumeDate(normalizeDate(row?.['resumeDate']));
  }

  const handleCloseResumePopup = () => {
    setResumePopup(false);
    setPausePopup(true);
    setSelectedOption('resume_license')
  }

  useEffect(() => {
    if (!_.isEmpty(getWHProdGPDeviceList)) {
      const res = getWHProdGPDeviceList.hasOwnProperty('data') ? getWHProdGPDeviceList?.data : [];
      setDevicesList(res);
      dispatch({ type: GET_WH_ProdGP_DEVICE_LIST, payload: {} })
    }
  }, [getWHProdGPDeviceList]);

  useEffect(() => {
    if (!_.isEmpty(getTransferLicense)) {
      const res = getTransferLicense;
      if (res?.message && (res?.error_code == 12016 || res?.error_code == 12022)) {
        setOpenPopup(true);
        setWarningModal(false);
        setDialogueMessage(res.message);
      } else {
        setOpen(false);
        setOpenPopup(false);
        setSelectedDevice('');
      }
      dispatch({ type: GET_TRANSFER_LICENSE, payload: true })
    }
  }, [getTransferLicense]);

  useEffect(() => {
    if (!_.isEmpty(getDpInfo) && getDpInfo.hasOwnProperty('status') && getDpInfo.status == 1) {
      const dpInfo = getDpInfo?.data;
      setIsAllowed({isPauseAllowed: dpInfo?.IsPauseAllowed, isTransferAllowed: dpInfo?.isTransferAllowed});
      dispatch({ type: GET_DP_INFO, payload: {} })
    }
  }, [getDpInfo])

  const handleSelectPauseOption = (option) => {
    setSelectedOption(option);
    setPausePopup(true);
    if(option == 'pause_license') {
      handlePauseLicense();
    }
    setRadioValue(option);
    _q.action = option;
    history.push({ pathname: location.pathname, search: `?${getEncodedURI(_q)}` });
  }

  const DAY_MS = 1000 * 60 * 60 * 24;
  const startOfDayUTC = (d) => new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));

  const getPauseProgress = (pausedOn, resumeDate) => {
    if (!pausedOn || !resumeDate) {
      return { current: 0, total: 0 };
    }

    const start:any = startOfDayUTC(new Date(pausedOn));
    const resume:any = startOfDayUTC(new Date(resumeDate));
    const today:any = startOfDayUTC(new Date());

    const total = Math.max(0, Math.ceil((resume - start) / DAY_MS));

    let current = 0;

    if (today >= resume) {
      // Pause fully completed
      current = total;
    } else if (today >= start) {
      // ✅ Inclusive counting (start day = day 1)
      current = Math.floor((today - start) / DAY_MS) + 1;
    }

    return { current, total };
  };

  const getFirstDayOfNextMonth = () => moment().add(1, 'month').startOf('month').format('MMM D, YYYY');
  const enablePauseOption = hasLicensePermission('PauseLicenseRW') && isAllowed?.isPauseAllowed && (row['licenseType'] == 'Production' || row['licenseType'] == 'HA') && (row?.['pausedOn'] == '' || row?.['pausedOn'] == null);
  const enableCancelPauseOption = row['licenseType'] != 'Paused' && isFuturePauseDate(row?.['pausedOn']);
  const enableResumeOption = row['licenseType'] == 'Paused'|| isTodayOrFuturePauseDate(row?.['pausedOn']);

  const getStatus = () => {
    if (enablePauseOption) {
      return row?.['termDisplay']?.includes('Month') ? <>Auto Renews on {getFirstDayOfNextMonth()}</> : <>Auto Renews</>
    } else if (enableCancelPauseOption) {
      return (
        <>
          <div className='margin-bottom-2'>Pause Requested</div>
          <div className='label-text'>
            (Pause starts on {formatToReadable(row?.['pausedOn'])})
          </div>
        </>
      )
    } else if (enableResumeOption) {
      return (
        <>
          <div className='margin-bottom-2'>{`Paused for ${moment(row?.['pausedOn']).format("MMMM")}`}</div>
          {row?.['termDisplay']?.includes('Year') && <div className='label-text'>
            (Auto-resumes on {formatToReadable(row?.['resumeDate'])})
          </div>}
        </>
      )
    }
  }

  const getSyncConstants = () => {
    switch (radioValue) {
      case 'warehouse':
        return DEREGISTRATION_SYNC;
      case 'device_transfer':
        return DEVICE_MOVEMENT_SYNC;
      case 'site_transfer':
        return SITE_MOVEMENT_SYNC;
      case 'change_license':
        return CHANGE_LICENSE_SYNC;
      case 'pause_license':
        return PAUSE_LICENSE_SYNC;
      case 'cancel_pause':
        return CANCEL_PAUSE_LICENSE_SYNC;
      case 'resume_license':
        return RESUME_LICENSE_SYNC;
      case 'cancel-de-reg':
        return CANCEL_DE_REGISTER_SYNC;
      case 'transfer_license':
        return TRANSFER_LICENSE_SYNC;
      default:
        return null;
    }
  };

  const getK4Ids = (value) => {
    switch (value) {
      case 'device_transfer':
        return [row?.['k4Id'], _q?.newSiteId];
      case 'warehouse':
        return [];
      case 'change_license':
        return [];
      case 'cancel_pause':
        return [];
      case 'resume_license':
        return [];
      case 'cancel-de-reg':
        return [];
      case 'transfer_license':
        return [];
      default:
        return [row?.['k4Id']];
    }
  }

  const getDeviceIds = (value) => {
    switch (value) {
      case 'site_transfer':
        return [];
      case 'transfer_license':
        return [row?.['deviceId'], _q.toDeviceId];
      default:
        return [row?.['deviceId']];
    }
  }

  useEffect(() => {
    const syncType = getSyncConstants();
    if (!syncType) {
      trackInventorySyncStatusData(getK4Ids(_q.action), getDeviceIds(_q.action));
      return;
    };

    trackInventorySyncStatusData(getK4Ids(radioValue), getDeviceIds(radioValue), syncType);
  }, [radioValue]);

  useEffect(() => {
    if (_.isEmpty(trackInventoryStatusData)) return;

    const status = trackInventoryStatusData?.status;
    const syncType = getSyncConstants();

    // if (!syncType) return;

    if (status == 'DONE' || status == 'FAILED' || status == 'NOT_STARTED') {
      setSyncInprogress(false);
      delete _q.newSiteId;
      delete _q.action;
      delete _q.toDeviceId;
      history.push({ pathname: location.pathname, search: `?${getEncodedURI(_q)}` });
      return;
    }

    if (status == 'IN_PROGRESS') {
      setSyncInprogress(true);
      setRequestType(trackInventoryStatusData?.request_type);
      const timer = setTimeout(() => {
        trackInventorySyncStatusData(getK4Ids(radioValue ? radioValue : _q.action), getDeviceIds(_q.action), syncType);
      }, POLL_INTERVAL);

      return () => clearTimeout(timer);
    }
  }, [trackInventoryStatusData]);

  const getTooltipText = () => {
    switch (requestType) {
      case DEREGISTRATION_SYNC:
        return 'DeRegistration is in progress.';
      case DEVICE_MOVEMENT_SYNC:
        return 'Device Movement is in progress.';
      case SITE_MOVEMENT_SYNC:
        return 'Site Movement is in progress.';
      case CHANGE_LICENSE_SYNC:
        return 'Change License is in progress.';
      case PAUSE_LICENSE_SYNC:
        return 'Pause License is in progress.';
      case CANCEL_PAUSE_LICENSE_SYNC:
        return 'Cancel Pause is in progress.';
      case RESUME_LICENSE_SYNC:
        return 'Resume License is in progress.';
      case CANCEL_DE_REGISTER_SYNC:
        return 'Cancel DeRegistration is in progress.';
      case TRANSFER_LICENSE_SYNC:
        return 'Transfer License is in progress.';
      default:
        return '';
    }
  };

  return (
    <div className={(row['deviceId']?.startsWith('RS') || row['deviceId']?.startsWith('RM')) ? "tab-content internalPadding" : "tab-content"}>

      <SectionTitleWithHr
        title="Current Device Association"
        showRadio={false}
      /><br />

      <Grid container display={'flex'} alignItems={'center'}>
        <Grid item xs={8.5} sm={8.5} md={8.5} lg={8.5}>
          <LabelValueDisplay
            label="Device Hierarchical Path"
            value={`${row['dpname']} / ${row['name']} / ${row['deviceName']}`}
            paddingLeft={10}
          />
        </Grid>
        <Grid item xs={3.5} sm={3.5} md={3.5} lg={3.5} display={'flex'} gap={'10px'}>
          <AddButton
            onAddClick={() => {
              if (!syncInprogress) {
                setSelectedOption('move_device');
                setOpenPopup(true);
              }
            }}
            addLabel={syncInprogress ? 'In Progress' : 'Move Device'}
            icon={move_site_icon}
            disabled={syncInprogress}
            tooltip={syncInprogress ? getTooltipText() : ''}
          />
        </Grid>
      </Grid>


      {row['licenseType'] != 'None' && <Grid container display={'flex'} alignItems={'flex-end'}>
        <SingleLineDisplay top={4} bottom={15} />
        <Grid item xs={3} sm={3} md={3} lg={3} className='licenceMaxWidth'>
          <LabelValueDisplay
            label="License"
            value={`${row['tierAlias']}`}
            infoText='Change License can be used to move from the Current License Tier / Term to a Different license Tier / Term (Subject to business rules specified under MSA). Either Or both of the License Tier, Term can be updated during the Change License.'
            paddingLeft={10}
          />
        </Grid>
        <Grid item xs={1} sm={1} md={1} lg={1}>
          <LabelValueDisplay
            label="Term"
            value={row?.['termDisplay']}
          />
        </Grid>
        <Grid item xs={1.5} sm={1.5} md={1.5} lg={1.5}>
          <LabelValueDisplay
            label="Term Ends"
            value={row?.['termValue'] == -1 ? "Not Applicable" : formatToReadable(row?.license_expiry_date)}
          />
        </Grid>
        <Grid item xs={3} sm={3} md={3} lg={3} style={{ whiteSpace: 'pre-line' }}>
          <LabelValueDisplay
            label="Status"
            value={getStatus()}
          />
        </Grid>
        <Grid item xs={3.5} sm={3.5} md={3.5} lg={3.5} display={'flex'} gap={'5px'} className="marginleftAuto">
          {enablePauseOption && <AddButton onAddClick={() => handleSelectPauseOption('pause_license')} addLabel={syncInprogress ? 'In Progress' : 'Pause'} icon={pause_filled} disabled={syncInprogress} tooltip={syncInprogress ? getTooltipText() : ''} />}
          {enableCancelPauseOption && <AddButton onAddClick={() => handleSelectPauseOption('cancel_pause')} addLabel={syncInprogress ? 'In Progress' : 'Cancel Pause'} icon={pause_filled} disabled={syncInprogress} tooltip={syncInprogress ? getTooltipText() : ''} maxWidth={'127px'} minWidth={'127px'}/>}
          {enableResumeOption && <AddButton onAddClick={() => handleSelectPauseOption('resume_license')} addLabel={syncInprogress ? 'In Progress' : 'Resume'} icon={resume_filled} disabled={syncInprogress} tooltip={syncInprogress ? getTooltipText() : ''} />}
          <AddButton
            onAddClick={() => {
              if (!syncInprogress) {
                setSelectedOption('change_license');
                setOpenPopup(true);
              }
            }}
            addLabel={syncInprogress ? 'In Progress' : 'Change'}
            icon={change_license_icon} disabled={syncInprogress}
            tooltip={syncInprogress ? getTooltipText() : ''}
          />
        </Grid>
      </Grid>}


      {row['deRegisteredDate'] && isTodayOrFuture(row['deRegisteredDate']) && <>
        <SingleLineDisplay top={4} bottom={25} />
        <Grid container display={'flex'} alignItems={'center'}>
          <Grid item xs={8.5} sm={8.5} md={8.5} lg={8.5}>
            <LabelValueDisplay
              label="DeRegistration Date"
              value={`${row['deRegisteredDate']}`}
              paddingLeft={10}
            />
          </Grid>
          <Grid item xs={3.5} sm={3.5} md={3.5} lg={3.5} display={'flex'} gap={'10px'}>
            <AddButton onAddClick={() => { setSelectedOption('cancel-de-reg'); setOpenPopup(true) }} addLabel={syncInprogress ? 'In Progress' : 'Cancel DeRegistration'} disabled={syncInprogress} tooltip={syncInprogress ? getTooltipText() : ''} />
          </Grid>
        </Grid>
        <SingleLineDisplay top={4} bottom={25} />
      </>}

      <AddEditInterfaceModal
        open={openPopup}
        onClose={() => { setOpenPopup(false); handleResetValues() }}
        onSave={() => {
          if (radioValue === 'change_license') {
            if(errorCode == 14015 || errorCode == 14016) {
              setOpenPopup(false);
              setOpen(false);
              handleResetValues();
              return;
            }
            handleChangeLicense();
          } else if (radioValue === 'transfer_license') {
            handleConfirm();
          } else if (radioValue === 'warehouse' && _.isEmpty(deRegistrationReasons)) {
            handleWarehouseClick();
          } else {
            setWarningModal(true);
            setOpenPopup(false);
          }
        }}
        saveText={radioValue == 'change_license' && (errorCode == 14015 || errorCode == 14016) ? 'Ok' : radioValue == 'change_license' ? 'Change License' : radioValue == 'transfer_license' ? 'Transfer License' : radioValue == 'device_transfer' ? 'Move Device' : radioValue == 'site_transfer' ? 'Move Site' : radioValue == 'cancel-de-reg' ? 'Cancel DeRegistration' : 'Move To Warehouse'}
        disableSave={handleSaveDisabled()}
        title={selectedOption == 'change_license' ? 'Change License' : selectedOption == 'cancel-de-reg' ? 'Cancel DeRegistration' : 'Move Device'}
        layout={getLayout()}
      />

      <AddEditInterfaceModal
        open={pausePopup}
        onClose={() => { setPausePopup(false); handleResetValues() }}
        onSave={() => {
          if(selectedOption == 'pause_license') {
            if(errorCode == 11035) {
              setOpenPopup(false);
              setOpen(false);
              handleResetValues();
              return;
            } else {
              setConfirmPauseResumePopup(true);
              setPausePopup(false);
            }
          }
          if(selectedOption == 'cancel_pause') {
            getCancelPauseLicenseData(row?.['deviceId'], row?.['k4Id']);
            _q.action = selectedOption;
            history.push({ pathname: location.pathname, search: `?${getEncodedURI(_q)}` });
          }
          if(selectedOption == 'resume_license' || resumePopup) {
            if(enableCancelPauseOption){
              setResumePopup(true);
              //call resume api for maxResume date
              getResumeLicenseData(row?.['deviceId'], formatDate(resumeDate));
            }
            else{
              setIsResumeNow(true);
              setConfirmPauseResumePopup(true);
            }
            setPausePopup(false);
          }
        }}
        maxWidth={(selectedOption == 'pause_license') ? '900px' : '480px'}
        width={(selectedOption == 'pause_license') ? 'unset' : '480px'}
        saveText={errorCode == 11035 ? 'Ok' : selectedOption == 'cancel_pause' ? 'Cancel Pause Request' : selectedOption == 'resume_license' ? enableCancelPauseOption ? 'Change Resume Date': 'Resume Now' : 'Confirm'}
         cancelText={selectedOption == 'cancel_pause' ? 'Cancel' : (selectedOption == 'resume_license' && !enableCancelPauseOption) ? 'Change Resume Date' : 'Cancel'}
        onCancelSave={handleChangePauseSchedule}
        title={resumePopup ? 'Resume License' : selectedOption == 'cancel_pause' ? 'Cancel Pause' : selectedOption == 'resume_license' ? 'Resume License' : 'Pause License'}
        layout={getPauseLicenseLayout()}
        showCancel={errorCode == 11035 ? false : true}
        disableSave={(selectedOption == 'pause_license' && row?.['termDisplay']?.includes('Year') && pauseDate > resumeDate)}
      />

      <AddEditInterfaceModal
        open={resumePopup}
        onClose={ handleCloseResumePopup}
        onSave={() => {
          if(selectedOption == 'cancel_pause') {
            getCancelPauseLicenseData(row?.['deviceId']);
            _q.action = selectedOption;
            history.push({ pathname: location.pathname, search: `?${getEncodedURI(_q)}` });
          }
          if(selectedOption == 'resume_license' || resumePopup) {
            setConfirmPauseResumePopup(true);
            setResumePopup(false);
          }
        }}
        maxWidth={'900px'}
        width={'unset'}
        saveText={errorCode == 11035 ? 'Ok' : selectedOption == 'cancel_pause' ? 'Cancel Pause Request' : selectedOption == 'resume_license' ? 'Update' : 'Confirm'}
        cancelText={ 'Cancel'}
        onCancelSave={handleCloseResumePopup}
        title={resumePopup ? 'Resume License' : selectedOption == 'cancel_pause' ? 'Cancel Pause' : selectedOption == 'resume_license' ? 'Resume License2' : 'Pause License'}
        layout={getResumeLicenseLayout()}
        showCancel={errorCode == 11035 ? false : true}
        disableSave={pauseDate > resumeDate}
      />

      <AddEditInterfaceModal
        open={confirmPauseResumePopup}
        onClose={() => { setConfirmPauseResumePopup(false); handleResetValues() }}
        onSave={() => {
          if(selectedOption == 'resume_license') {
            getResumeLicenseData(row?.['deviceId'], isResumeNow ? new Date()?.toISOString()?.split('T')[0] : formatDate(resumeDate), true);
            _q.action = selectedOption;
            history.push({ pathname: location.pathname, search: `?${getEncodedURI(_q)}` });
            setIsResumeNow(false);
          } else if(isChangeSchedule) {
            const payload = {
                deviceId: row.deviceId,
                k4Id: row.k4Id,
                pauseDate: row['termDisplay'].includes('Year') ? moment(pauseDate)?.format('YYYY-MM-DD') : undefined,
                resumeDate: row['termDisplay'].includes('Year') ? moment(resumeDate)?.format('YYYY-MM-DD') : undefined,
                validated: true,
              };
            getPauseLicenseData(payload);
          } else if(selectedOption == 'pause_license') {
            handlePauseLicense();
            _q.action = selectedOption;
            history.push({ pathname: location.pathname, search: `?${getEncodedURI(_q)}` });
          }
        }}
        saveText='Confirm'
        title={'Acknowledgment'}
        layout={getPauseLicenseConfirmLayout()}
      />

      <InfoModal
        open={warningModal}
        onClose={() => { setWarningModal(false); handleResetValues() }}
        onConfirm={handleConfirm}
        saveText={radioValue == 'change_license' ? 'Change License' : radioValue == 'pause_license' ? 'Pause License' : 'Confirm & Move'}
        warningInfo={getWarningInfo(radioValue)}
      />

      {deviceLinkStatusLoading || getDeRegisterDeviceLoading || setInventoryAssignDeviceToWarehouse || setUpgradeInventoryLicenseLoading || getSwapModeLoading || inventoryListingLoading || getDeviceTransferLoading || setCancelDeRegister || setLicenseTypesLoading || setPauseLicense || setResumeLicense || setWHProdGPDeviceListLoading || setTransferLicenseLoading || setDpInfoLoading || setCancelPauseLicenseLoading ? (
        <CustomLoader
          showLoader={true}
          loadingText={"Please wait..."}
        />
      ) : null}
    </div>
  );
}


const mapStateToProps = (state) => ({
  deviceLinkStatusLoading: state.authReducer.getDeviceLinkStatusLoading,
  getDeRegisterDeviceLoading: state.authReducer.getDeRegisterDeviceLoading,
  setInventoryAssignDeviceToWarehouse: state.authReducer.setInventoryAssignDeviceToWarehouse,
  setUpgradeInventoryLicenseLoading: state.authReducer.setUpgradeInventoryLicenseLoading,
  getSwapModeLoading: state.authReducer.getSwapModeLoading,
  inventoryListingLoading: state.authReducer.inventoryListingLoading,
  getDeviceTransferLoading: state.authReducer.getDeviceTransferLoading,
  moveToWarehouseData: state.authReducer.inventoryAssignDeviceToWarehouse,
  inventoryUpgradeLicense: state.authReducer.inventoryUpgradeLicense,
  createVesselData: state.authReducer.createVessel,
  inventoryChangeGroupData: state.authReducer.inventoryChangeGroup,
  fetchResourcesData: state.authReducer.fetchResources,
  getDeviceTransfer: state.authReducer.getDeviceTransfer,
  setCancelDeRegister: state.authReducer.setCancelDeRegister,
  getCancelDeRegister: state.authReducer.getCancelDeRegister,
  setLicenseTypesLoading: state.authReducer.setLicenseTypesLoading,
  getPauseLicense: state.authReducer.getPauseLicense,
  setPauseLicense: state.authReducer.setPauseLicense,
  setResumeLicense: state.authReducer.setResumeLicense,
  getResumeLicense: state.authReducer.getResumeLicense,
  getWHProdGPDeviceList: state.authReducer.getWHProdGPDeviceList,
  setWHProdGPDeviceListLoading: state.authReducer.setWHProdGPDeviceListLoading,
  setTransferLicenseLoading: state.authReducer.setTransferLicenseLoading,
  getTransferLicense: state.authReducer.getTransferLicense,
  getDpInfo: state.authReducer.getDpInfo,
  setDpInfoLoading: state.authReducer.setDpInfoLoading,
  getCancelPauseLicense: state.authReducer.getCancelPauseLicense,
  setCancelPauseLicenseLoading: state.authReducer.setCancelPauseLicenseLoading,
  trackInventoryStatusData: state.authReducer.trackInventoryStatusData,
});

export default withRouter(
  connect(mapStateToProps, { getDeviceLinkStatusData, getDeRegisterDeviceData, moveDeviceToWarehouse, upgradeInventoryLicense, getSwapModeData, createVessel, getDeviceTransferData, inventoryChangeGroup, fetchResources, getCancelDeRegisterData, getPauseLicenseData, getResumeLicenseData, getWHProdGPDeviceListData, getTransferLicenseData, getOrganisationInfo, getCancelPauseLicenseData, trackInventorySyncStatusData })(TransferTab)
);